import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import CustomerOverview from './components/customer/customerOverview';
import CustomerForm from './components/customer/customerForm';
import CustomerDetails from './components/customer/customerDetails';
import Login from './components/auth/login/login';
import ForgotPassword from './components/auth/forgot-password/page';
import ResetPassword from './components/auth/reset-password/page';
import SetPassword from './components/auth/set-password/page';
import LoginSSO from './components/auth/login/LoginSSO';
import OrdersMain from './components/orders/OrdersMain';
import OrderDetails from './components/orders/OrderDetails';
import LicensesMain from './components/licenses/LicensesMain';
import withAuth from "./components/auth/withAuth";
import AccordianTest from './components/customer/accordian';
import { ToastContextProvider } from './context/toastContext';
import UserManagement from './components/user/user';
import CustomerViews from './components/customer/customerView';
import OrderCreate from './components/orderCreate/OrderCreate';
import { PartnerIdContextProvider } from './context/partnerIdContext';
import Layout from './components/Layout';
import AdminMain from './components/admin/AdminMain';
// import AuditTrail from './components/admin/audit/AuditTrail';
import UsersMain from './components/admin/users/UsersMain';
import PlatformMain from './components/admin/platform/PlatformMain';

function App() {
  return (
    <PartnerIdContextProvider>
      <ToastContextProvider>
        <Router>
          <Routes>
            <Route path='/' element={<Layout />}>
              <Route path="/" element={<Navigate to="/login" replace />} />
              {/* <Route path="/login" element={<Login />} /> */}
              <Route path="/login" element={<LoginRouteHandler />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/set-password" element={<SetPassword />} />
              <Route path="/customer/overview" element={<CustomerOverview />} />
              <Route path="/customer/new" element={<CustomerForm />} />
              <Route path="/customer/details/:companyName/:id" element={<CustomerDetails />} />
              <Route path="/customer/view/:companyName/:sitename/:id" element={<CustomerViews />} />
              <Route path="/orders" element={<OrdersMain />} />
              <Route path="/orders/details" element={<OrderDetails />} />
              <Route path="/licenses" element={<LicensesMain />} />
              <Route path="/admin/partner" element={<UserManagement />} />
              <Route path="/orders/create" element={<OrderCreate />} />
              <Route path="/admin" element={<AdminMain />} />
              <Route path="/admin/users" element={<UsersMain />} />
              <Route path="/admin/platform" element={<PlatformMain />} />
              {/* don' remove it kept it for later implementation */}
              {/* <Route path="/admin/audit-trail" element={<AuditTrail />} /> */} 

              {/* Uncomment and adjust these routes as needed */}
              {/* <Route path="/customer/overview" element={withAuth(CustomerOverview)({})} />
              <Route path="/customer/new" element={withAuth(CustomerForm)({})} />
              <Route path="/customer/details" element={withAuth(CustomerDetails)({})} />
              <Route path="/orders" element={withAuth(OrdersMain)({})} />
              <Route path="/orders/details" element={withAuth(OrderDetails)({})} />
              <Route path="/licenses" element={withAuth(LicensesMain)({})} />
              <Route path="/accordian" element={withAuth(AccordianTest)({})} /> */}
            </Route>
          </Routes>
        </Router>
      </ToastContextProvider>
    </PartnerIdContextProvider>
  );
}

const LoginRouteHandler = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  if (queryParams.has('mo_fb_jwt_token')) {
    return <LoginSSO />;
  }
  return <Login />;
}

export default App;
